import React from 'react'
import { Grid } from '@mui/material'
import { Text } from 'components/texts'
import { Input } from 'components/forms/components'
import { ItemsSelect } from 'components/forms/components/Select/custom'


/**
 * Esta es la plantilla para cuando se busque por los datos basicos de las actividades en una inscripcion
 */
export default function InscripcionActividadesAcademiaTemplate({ reset, errors, register }) {

    return (
        <>
            <Grid container mt={2} mb={1}>
                <Text fontWeight={'bold'}>Según datos de:</Text><br />
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <ItemsSelect name={"id_actividad"} keyValue={"tipo_actividad"} register={register} errors={errors} wantToReset={reset}/>
                </Grid>

                <Grid item xs={4}>
                    <ItemsSelect name={"id_actividades"} keyValue={"actividad"} register={register} errors={errors} wantToReset={reset} searcheable/>
                </Grid>

                <Grid item xs={4}>
                    <ItemsSelect name={"id_modalidad_cursos"} keyValue={"modalidad_cursos"} register={register} errors={errors} wantToReset={reset}/>
                </Grid>

                <Grid item xs={6}>
                    <Input label="Test de Nivel" width={"100%"} name={"testNivel"} register={register} errors={errors} uppercase />
                </Grid>

                <Grid item xs={6}>
                    <ItemsSelect label={"Año"} name={"id_curso_escolar"} keyValue={"curso_escolar"} register={register} errors={errors} wantToReset={reset}/>
                </Grid>
            </Grid>
        </>
    )
}
